import i18n from "lib/i18n";

export default class ErrorItems {
  static render() {
    return [{
      dataAttributes: {},
      icon: "delete",
      label: i18n.t("editorial_menu.error.label"),
      trackAction: "Error",
      url: i18n.t("editorial_menu.error.url"),
    }];
  }
}
